import { createApi } from '@reduxjs/toolkit/query/react'

import { IUser } from 'core-components/sitebuilder/models/IUser'
import { readFromCache, saveToCache } from 'src/core/classes/cache/Cache'
import StorageKeys from 'src/core/classes/cache/StorageKeys'
import { ICountry } from 'src/core/classes/models/IReference'
import { MarketApi } from 'src/core/classes/services/api/MarketApi'
import { RootState } from 'src/core/store'
import Logger from 'src/core/utils/Logger'

import { getProcedureUrl } from './helpers/getBaseUrl'
import { getCustomQuery } from './helpers/getCustomQuery'

export const referenceCountriesCodeApi = createApi({
  reducerPath: '@app/api/referenceCountriesCode',
  baseQuery: getCustomQuery({
    storageKey: StorageKeys.countriesCode,
    baseUrl: getProcedureUrl('spApp_getCountries'),
  }),
  endpoints: (builder) => ({
    getReferenceCountriesCode: builder.query<Record<string, string[]>, void>({
      async queryFn(force, { dispatch, getState }, _extraOptions, fetchWithBQ) {
        try {
          const cache = readFromCache(StorageKeys.countriesCode)
          if (cache) {
            return { data: cache }
          }

          const { data } = await fetchWithBQ({
            url: '',
            method: 'POST',
          })
          const state = getState() as unknown as RootState

          const items = saveCompanies(data as { Data: ICountry[] }, state.siteBuilder.user)

          const result: Record<string, string[]> = {}
          items.forEach((element: ICountry) => {
            if (!result[element.phoneCode]) {
              result[element.phoneCode] = [element.value]
            } else {
              result[element.phoneCode].push(element.value)
            }
          })

          saveToCache(StorageKeys.countriesCode, result)

          return { data: result }
        } catch (error) {
          Logger.error('Error handling the response:', error)
          return { data: {} }
        }
      },
    }),
  }),
})

const saveCompanies = (data: ICountry[] | { Data: ICountry[] }, user: IUser) => {
  const region = MarketApi.getRegion(user.geoMarket).Region
  const items = data instanceof Array ? data : data.Data
  const responseCountry = items.filter((el: ICountry) => el.region === region)
  responseCountry.sort((a: ICountry, b: ICountry) => {
    if (a.name > b.name) {
      return 1
    }
    if (a.name < b.name) {
      return -1
    }
    return 0
  })
  const countriesResult = responseCountry.map((element: ICountry) => ({
    value: element.value,
    name: element.name,
  }))
  saveToCache(`${StorageKeys.countries}_${region}`, countriesResult, true)

  return items
}

export const { useGetReferenceCountriesCodeQuery } = referenceCountriesCodeApi
